<template>
  <main class="rich-articel">
  </main>
</template>

<script>
export default {
  name: "cancerP",
};
</script>
<style scoped lang='less'>

</style>


// WEBPACK FOOTER //
// src/components/product/cancerP.vue